import { endPoints, getVisitorServiceAPIEndPoint, getVisitorServiceUrl } from "./api-constants";
import { apiService } from "./base-api-service";

class VisitorService {
  VisitorService(url) {
    return getVisitorServiceAPIEndPoint(url);
  }
  UpdateVisitorDwh(data) {
    const createUserEndpoint = this.VisitorService(`${endPoints.visitorservice.UPDATE}`);
    return apiService.patch(createUserEndpoint, data);
  }
}
export default new VisitorService();